"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jsxRuntime = require("react/jsx-runtime");
const FullBlockCta = _ref => {
  let {
    desc,
    primaryBtnHref,
    primaryBtnText
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "block",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      className: "text-center max-w-[934px] emphasis_para",
      children: desc
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "flex justify-center mt-8",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("a", {
        href: primaryBtnHref,
        className: "primary-btn items-center",
        children: primaryBtnText
      })
    })]
  });
};
var _default = FullBlockCta;
exports.default = _default;